document.addEventListener('DOMContentLoaded', () => {
const component = document.getElementById('shFreeShipping');
if (!component) return;
const country = (component.dataset.country || '').toUpperCase();
const currency = (component.dataset.currency || '').toUpperCase();
const rawLocale = component.dataset.locale || document.documentElement.lang || 'es';
const language = rawLocale.toLowerCase().split('-')[0].replace(/^nb$/, 'no');   
const shippingConfig = {
NO: {
threshold: 14900,
shippingCost: 999
},
DE: {
threshold: 10900,
shippingCost: 699
},
ES: {
threshold: 10000,
shippingCost: 495
},
BE: {
threshold: 10900,
shippingCost: 799
},
FR: {
threshold: 10900,
shippingCost: 699
},
IT: {
threshold: 10900,
shippingCost: 799
},
PT: {
threshold: 10900,
shippingCost: 799
}
};
const copyConfig = {
no: {
locale: 'nb-NO',
adding: 'Legger til …',
add: 'Legg til',
heading: 'Gjør bestillingen komplett',
success: '🎉 Du har fått gratis frakt!',
remaining: (amount) => `Du mangler <strong>${amount}</strong> for å få gratis frakt.`,
shipping: (cost, threshold) => `Frakt: ${cost} · Gratis fra ${threshold}`
},
de: {
locale: 'de-DE',
adding: 'Wird hinzugefügt…',
add: 'Hinzufügen',
heading: 'Ergänze deine Bestellung',
success: '🎉 Deine Bestellung ist versandkostenfrei!',
remaining: (amount) => `Noch <strong>${amount}</strong> bis zum kostenlosen Versand.`,
shipping: (cost, threshold) => `Versand: ${cost} · Kostenlos ab ${threshold}`
},
es: {
locale: 'es-ES',
adding: 'Añadiendo...',
add: 'Añadir',
heading: 'Completa tu pedido',
success: '🎉 ¡Has conseguido envío gratuito!',
remaining: (amount) => `Te faltan <strong>${amount}</strong> para conseguir envío gratuito.`,
shipping: (cost, threshold) => `Envío: ${cost} · Gratis desde ${threshold}`
},
fr: {
locale: 'fr-FR',
adding: 'Ajout...',
add: 'Ajouter',
heading: 'Complétez votre commande',
success: '🎉 Vous avez obtenu la livraison gratuite !',
remaining: (amount) => `Il vous manque <strong>${amount}</strong> pour la livraison gratuite.`,
shipping: (cost, threshold) => `Livraison : ${cost} · Gratuite dès ${threshold}`
},
it: {
locale: 'it-IT',
adding: 'Aggiunta in corso...',
add: 'Aggiungi',
heading: 'Completa il tuo ordine',
success: '🎉 Hai ottenuto la spedizione gratuita!',
remaining: (amount) => `Ti mancano <strong>${amount}</strong> per ottenere la spedizione gratuita.`,
shipping: (cost, threshold) => `Spedizione: ${cost} · Gratuita da ${threshold}`
},
nl: {
 locale: 'nl-BE',
 adding: 'Toevoegen…',
 add: 'Toevoegen',
 heading: 'Vul je bestelling aan',
 success: '🎉 Je hebt gratis verzending!',
 remaining: (amount) => `Je hebt nog <strong>${amount}</strong> nodig voor gratis verzending.`,
 shipping: (cost, threshold) => `Verzending: ${cost} · Gratis vanaf ${threshold}`
},
pt: {
locale: 'pt-PT',
adding: 'A adicionar...',
add: 'Adicionar',
heading: 'Complete a sua encomenda',
success: '🎉 Conseguiu envio gratuito!',
remaining: (amount) => `Faltam <strong>${amount}</strong> para obter envio gratuito.`,
shipping: (cost, threshold) => `Envio: ${cost} · Grátis a partir de ${threshold}`
}
};
const config = currency === 'EUR'
? shippingConfig[country]
: country === 'NO' && currency === 'NOK'
? { threshold: 165500, shippingCost: 11100 }
: null;
const copy = copyConfig[language] || copyConfig.es;
if (!config) {
component.hidden = true;
return;
}
const formatMoney = (cents) =>
new Intl.NumberFormat(copy.locale, {
style: 'currency',
currency,
currencyDisplay: currency === 'NOK' ? 'code' : 'symbol'
}).format(cents / 100);
const getRecommendationConfig = () => {
const dataElement = document.getElementById('shFreeShippingRecommendationData');
if (!dataElement) {
console.error('EXP-004: no se encontró la configuración de recomendaciones.');
return null;
}
try {
const data = JSON.parse(dataElement.textContent || '{}');
if (
!data ||
data.currency !== currency ||
!Array.isArray(data.products) ||
!Array.isArray(data.softFlaskProductIds)
) {
throw new Error('Configuración vacía o inválida.');
}
const softFlaskProductIds = data.softFlaskProductIds.map(Number);
if (
softFlaskProductIds.length === 0 ||
softFlaskProductIds.some((id) => !Number.isFinite(id) || id <= 0) ||
new Set(softFlaskProductIds).size !== softFlaskProductIds.length
) {
throw new Error('Lista de IDs de soft flask inválida.');
}
const buildRange = (minField, maxField, expectedMax) => {
const rangedProducts = data.products
.filter((product) => Number(product?.[minField]) >= 0)
.sort((a, b) => Number(a[minField]) - Number(b[minField]));
let expectedMin = 0;
for (const product of rangedProducts) {
const minRemaining = Number(product?.[minField]);
const maxRemaining = Number(product?.[maxField]);
if (
!product?.key ||
!Number.isFinite(minRemaining) ||
!Number.isFinite(maxRemaining) ||
minRemaining !== expectedMin ||
maxRemaining < minRemaining
) {
throw new Error('Rango de recomendación inválido.');
}
expectedMin = maxRemaining + 1;
}
if (rangedProducts.length === 0 || expectedMin !== expectedMax + 1) {
throw new Error('Jerarquía de recomendaciones incompleta.');
}
if (currency === 'EUR') return rangedProducts;
let nextMin = 0;
return rangedProducts.map((product) => {
const maxRemaining = Number(product.rangePrice);
if (!Number.isSafeInteger(maxRemaining) || maxRemaining < nextMin) {
throw new Error('Precio de mercado inválido para el rango de recomendación.');
}
const converted = { ...product, [minField]: nextMin, [maxField]: maxRemaining };
nextMin = maxRemaining + 1;
return converted;
});
};
return {
softFlaskProductIds,
standardProducts: buildRange(
'standardMinRemaining',
'standardMaxRemaining',
3500
),
flaskProducts: buildRange(
'flaskMinRemaining',
'flaskMaxRemaining',
2799
)
};
} catch (error) {
console.error('EXP-004: configuración de recomendaciones inválida:', error);
return null;
}
};
const recommendation = {
get container() {
return document.getElementById('shFreeShippingRecommendation');
},
get heading() {
return document.getElementById('shFreeShippingRecommendationHeading');
},
get image() {
return document.getElementById('shFreeShippingRecommendationImage');
},
get title() {
return document.getElementById('shFreeShippingRecommendationTitle');
},
get price() {
return document.getElementById('shFreeShippingRecommendationPrice');
},
get button() {
return document.getElementById('shFreeShippingRecommendationButton');
}
};
const hideRecommendation = () => {
if (!recommendation.container) return;
recommendation.container.hidden = true;
};
const addRecommendationToCart = async (variantId) => {
if (!variantId || !recommendation.button) return;
recommendation.button.disabled = true;
recommendation.button.textContent = copy.adding;
try {
const sections = [
{
id: 'main-cart-items',
section: document.getElementById('main-cart-items')?.dataset.id,
selector: '.js-contents'
},
{
id: 'cart-icon-bubble',
section: 'cart-icon-bubble',
selector: '.shopify-section'
},
{
id: 'cart-live-region-text',
section: 'cart-live-region-text',
selector: '.shopify-section'
},
{
id: 'main-cart-footer',
section: document.getElementById('main-cart-footer')?.dataset.id,
selector: '.js-contents'
}
];
const validSections = sections.filter((section) => section.section);
const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
method: 'POST',
headers: {
'Content-Type': 'application/json',
Accept: 'application/json'
},
body: JSON.stringify({
items: [{ id: variantId, quantity: 1 }],
sections: validSections.map((section) => section.section),
sections_url: window.location.pathname
})
});
if (!response.ok) {
throw new Error('No se pudo añadir el producto.');
}
const parsedState = await response.json();
validSections.forEach((section) => {
const sectionElement = document.getElementById(section.id);
if (!sectionElement) return;
const elementToReplace =
sectionElement.querySelector(section.selector) || sectionElement;
const sectionHTML = parsedState.sections?.[section.section];
if (!sectionHTML) return;
const parsedHTML = new DOMParser().parseFromString(sectionHTML, 'text/html');
const sourceElement = parsedHTML.querySelector(section.selector);
if (!sourceElement) return;
elementToReplace.innerHTML = sourceElement.innerHTML;
});
const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
if (!cartResponse.ok) {
throw new Error('No se pudo actualizar el carrito.');
}
const cart = await cartResponse.json();
if (
typeof publish === 'function' &&
typeof PUB_SUB_EVENTS !== 'undefined'
) {
publish(PUB_SUB_EVENTS.cartUpdate, {
source: 'free-shipping-recommendation',
productVariantId: variantId,
cartData: cart
});
}
updateProgress(cart);
} catch (error) {
console.error('Error al añadir recomendación:', error);
const currentButton = recommendation.button;
if (currentButton) {
currentButton.disabled = false;
currentButton.textContent = copy.add;
}
}
};
const updateRecommendation = (cart, remaining) => {
if (!recommendation.container) return;
if (remaining === 0) {
hideRecommendation();
return;
}
const recommendationConfig = getRecommendationConfig();
if (!recommendationConfig) {
hideRecommendation();
return;
}
const cartItems = cart.items || [];
const cartProductIds = new Set(cartItems.map((item) => Number(item.product_id)));
const cartVariantIds = new Set(cartItems.map((item) => Number(item.variant_id)));
const softFlaskProductIds = new Set(recommendationConfig.softFlaskProductIds);
const hasSoftFlask = cartItems.some((item) =>
softFlaskProductIds.has(Number(item.product_id))
);
if (
(hasSoftFlask && remaining > Number(recommendationConfig.flaskProducts.at(-1).flaskMaxRemaining)) ||
(!hasSoftFlask && remaining > Number(recommendationConfig.standardProducts.at(-1).standardMaxRemaining))
) {
hideRecommendation();
return;
}
const minField = hasSoftFlask
? 'flaskMinRemaining'
: 'standardMinRemaining';
const maxField = hasSoftFlask
? 'flaskMaxRemaining'
: 'standardMaxRemaining';
const products = hasSoftFlask
? recommendationConfig.flaskProducts
: recommendationConfig.standardProducts;
const currentIndex = products.findIndex(
(product) =>
remaining >= Number(product[minField]) &&
remaining <= Number(product[maxField])
);
if (currentIndex === -1) {
hideRecommendation();
return;
}
if (recommendation.heading) {
recommendation.heading.textContent = copy.heading;
}
const candidates = products.slice(currentIndex);
for (const product of candidates) {
if (product?.resolved !== true) {
console.error(
'EXP-004: producto de recomendación no resuelto:',
product?.key || 'desconocido'
);
hideRecommendation();
return;
}
if (product.available !== true || !product.variantId) {
if (hasSoftFlask) {
hideRecommendation();
return;
}
continue;
}
const productId = Number(product.productId);
const variantId = Number(product.variantId);
const price = Number(product.price);
if (
!Number.isFinite(productId) ||
!Number.isFinite(variantId) ||
!Number.isFinite(price) ||
price <= 0 ||
!product.title
) {
console.error(
'EXP-004: datos incompletos en producto de recomendación:',
product?.key || 'desconocido'
);
hideRecommendation();
return;
}
if (price < remaining) {
if (hasSoftFlask) {
hideRecommendation();
return;
}
continue;
}
if (cartProductIds.has(productId) || cartVariantIds.has(variantId)) {
continue;
}
if (recommendation.image) {
recommendation.image.src = product.image || '';
recommendation.image.alt = product.title;
}
if (recommendation.title) {
recommendation.title.textContent = product.title;
}
if (recommendation.price) {
recommendation.price.textContent = formatMoney(price);
}
if (recommendation.button) {
recommendation.button.disabled = false;
recommendation.button.textContent = copy.add;
recommendation.button.onclick = () => addRecommendationToCart(variantId);
}
recommendation.container.hidden = false;
return;
}
hideRecommendation();
};
const updateProgress = (cart) => {
const currentComponent = document.getElementById('shFreeShipping');
const currentMessage = document.getElementById('shFreeShippingMessage');
const currentProgress = document.getElementById('shFreeShippingProgress');
const currentShipping = document.getElementById('shFreeShippingShipping');
if (
!currentComponent ||
!currentMessage ||
!currentProgress ||
!currentShipping
) {
return;
}
const cartTotal = Number(cart.items_subtotal_price || 0);
if (cart.currency !== currency || !Number.isFinite(cartTotal) || cartTotal <= 0) {
currentComponent.hidden = true;
hideRecommendation();
return;
}
currentComponent.hidden = false;
const remaining = Math.max(config.threshold - cartTotal, 0);
const percentage = Math.min((cartTotal / config.threshold) * 100, 100);
currentProgress.style.width = `${percentage}%`;
if (cartTotal >= config.threshold) {
currentMessage.textContent = copy.success;
hideRecommendation();
} else {
currentMessage.innerHTML = copy.remaining(formatMoney(remaining));
updateRecommendation(cart, remaining);
}
currentShipping.textContent = copy.shipping(
formatMoney(remaining === 0 ? 0 : config.shippingCost),
formatMoney(config.threshold)
);
};
const getCart = async () => {
try {
const response = await fetch(`${window.Shopify.routes.root}cart.js`);
if (!response.ok) return;
const cart = await response.json();
updateProgress(cart);
} catch (error) {
console.error('Error al obtener carrito:', error);
}
};
getCart();
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
if (!event || !event.cartData) return;
requestAnimationFrame(() => {
requestAnimationFrame(() => {
updateProgress(event.cartData);
});
});
});
}
});
